import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Target, CheckCircle, Users, Zap, TrendingUp, Shield } from 'lucide-react';
import CommonContactUs from './CommonContactUs';

const JobMatchingPage = () => {
  return (
    <div className="w-full min-h-screen">
      {/* Hero Section */}
      <section className="bg-[#1A193B] pt-20 text-white">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-3 lg:px-4 py-24 lg:py-32">
        <div className="container mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              Job Matching
            </h1>
            <p className="text-xl md:text-2xl text-teal-100 mb-6">
              {/* AI-powered matching for perfect job-candidate alignment */}
              Connecting skilled professionals with the right opportunities_
            </p>
            <p className="text-lg text-teal-200">
              Our Services
            </p>
          </motion.div>
        </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 px-4 md:px-6 bg-white">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex items-center gap-4 mb-6"
            >
              <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-gradient-to-r from-teal-500 to-cyan-500 flex-shrink-0">
                <Target className="w-6 h-6 text-white" />
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800">
                Job Matching Services
              </h2>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-lg text-gray-600 mb-8"
            >
              Our job matching services connect skilled professionals with opportunities that align with their expertise, career goals, and personal preferences. We use advanced algorithms and personalized guidance to create perfect matches.
              </motion.p>

            {/* Services Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bg-gray-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
              How We Connect You With The Right Opportunities
              </h3>
              <div className="space-y-4">
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">AI-Powered Matching</h4>
                    <p className="text-gray-600">
                    Our sophisticated algorithms analyze your skills, experience, and preferences to identify opportunities that match your profile. This technology-driven approach ensures more accurate and relevant job matches.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                    Skills Assessment
                    </h4>
                    <p className="text-gray-600">
                    We conduct comprehensive skills assessments to understand your technical capabilities and identify areas where you excel. This helps us match you with roles where you can leverage your strengths.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                    Career Coaching
                    </h4>
                    <p className="text-gray-600">
                    Our career coaches provide guidance on career development, helping you make informed decisions about job opportunities and long-term career planning.
                      </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">
                    Interview Preparation
                    </h4>
                    <p className="text-gray-600">
We prepare you for interviews with targeted companies, providing insights into the company culture, interview process, and potential questions.
 </p>
                  </div>
                </div>
                {/* <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Real-Time Matching</h4>
                    <p className="text-gray-600">
                      Instant matching notifications and updates as new opportunities or candidates become available that meet your criteria.
                    </p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Custom Matching Criteria</h4>
                    <p className="text-gray-600">
                      Tailored matching parameters that can be customized based on specific requirements, preferences, and business needs.
                    </p>
                  </div>
                </div> */}
              </div>
            </motion.div>

            {/* Benefits Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="bg-teal-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Our Job Matching Process
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                  <Zap className="w-5 h-5 text-teal-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Profile Creation</h4>
                    <p className="text-gray-600">We start by creating a comprehensive profile that captures your skills, experience, career goals, and preferences.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Target className="w-5 h-5 text-teal-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Opportunity Matching                    </h4>
                    <p className="text-gray-600">Our system identifies opportunities that match your profile, considering both technical requirements and cultural fit.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <TrendingUp className="w-5 h-5 text-teal-600 mt-1 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Interview & Placement</h4>
                    <p className="text-gray-600">We support you through the interview process and help negotiate terms once you've found the perfect match.</p>
                  </div>
                </div>
              </div>
            </motion.div> */}

            {/* Process Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                {/* How Job Matching Works */}
                Our Job Matching Process
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center font-bold mb-3">
                    1
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">Profile Creation</h4>
                  <p className="text-gray-600">We start by creating a comprehensive profile that captures your skills, experience, career goals, and preferences.</p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center font-bold mb-3">
                    2
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">Opportunity Matching                    </h4>
                  <p className="text-gray-600">Our system identifies opportunities that match your profile, considering both technical requirements and cultural fit.</p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md">
                  <div className="w-10 h-10 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center font-bold mb-3">
                    3
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">Interview & Placement</h4>
                  <p className="text-gray-600">We support you through the interview process and help negotiate terms once you've found the perfect match.</p>
                </div>
              </div>
            </motion.div>

            {/* Features Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              className="bg-gray-50 p-6 rounded-xl mb-10"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Key Features
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
                  <span className="text-gray-700">Skills Assessment</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
                  <span className="text-gray-700">Culture Fit</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
                  <span className="text-gray-700">Experience Matching</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
                  <span className="text-gray-700">Location Preferences</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
                  <span className="text-gray-700">Salary Alignment</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
                  <span className="text-gray-700">Growth Potential</span>
                </div>
              </div>
            </motion.div> */}

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="flex justify-center gap-4 flex-wrap"
            >
              <Link to="/services">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-gray-100 text-gray-800 hover:bg-gray-200 px-6 py-3 rounded-lg font-medium transition-colors shadow-md inline-flex items-center"
                >
                  <span>Back to Services</span>
                </motion.button>
              </Link>
              <Link to="/contact">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white rounded-lg shadow-lg flex items-center space-x-2 transition-colors duration-300"
                >
                  <Target size={18} />
                  <span>Contact Us</span>
                </motion.button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      {/* <section id="job-matching-contact" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="bg-white p-8 rounded-xl shadow-lg"
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
                Get Started with Job Matching
              </h2>
              <p className="text-gray-600 mb-8 text-center">
                Ready to leverage AI-powered job matching? Contact us today to discuss your matching needs and requirements.
              </p>
              
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Company Name *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                      placeholder="Your company name"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Contact Person *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                      placeholder="Your name"
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                      placeholder="email@company.com"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                      placeholder="+1 (234) 567-8910"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      User Type
                    </label>
                    <select className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors">
                      <option value="">Select user type</option>
                      <option value="employer">Employer/Recruiter</option>
                      <option value="job-seeker">Job Seeker</option>
                      <option value="both">Both</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Number of Positions/Profiles
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                      placeholder="Number of positions or profiles to match"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Matching Requirements *
                  </label>
                  <textarea
                    required
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                    placeholder="Describe your specific matching requirements, such as skills, experience levels, location preferences, or any special criteria..."
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Current Challenges
                  </label>
                  <textarea
                    rows="3"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors"
                    placeholder="What challenges are you currently facing with job matching or candidate sourcing?"
                  />
                </div>

                <div className="text-center">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    type="submit"
                    className="px-8 py-3 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-colors shadow-lg"
                  >
                    Request Job Matching Services
                  </motion.button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </section> */}
       <section className="py-16 bg-[#1A193B] text-white">
        <CommonContactUs/>
      </section>
    </div>
  );
};

export default JobMatchingPage; 